import React from "react"
import css from "./ErrorBoundary.scss"
import ImageLoader from "@components/ImageLoader/ImageLoader"
import PrimaryButton from "@components/Button/Button"
import { captureException } from "@lib/sentry"

class ErrorBoundary extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            hasError: false,
            errorCode: null,
            error: null,
        }
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true,
            errorCode: error?.errorCode || 500,
            error: error?.message,
        }
    }
    componentDidCatch(error) {
        // Log the error to Sentry
        let normalizedError
        const errorPrefix = "500 ErrorBoundary page - "

        if (error instanceof Error) {
            normalizedError = new Error(errorPrefix + error.message)
            normalizedError.stack = error.stack
        } else if (typeof error === "string") {
            normalizedError = new Error(errorPrefix + error)
        } else {
            normalizedError = new Error(errorPrefix + "An unknown error occurred")
            normalizedError.originalError = error
        }
        captureException(normalizedError)
    }

    etGoHome = () => {
        window.location.href = "/"
    }

    render() {
        if (this.state.hasError && this.state.errorCode === 424) {
            // You can render any custom fallback UI
            return (
                <React.Fragment>
                    this is error
                    <div className="container-fluid">
                        <PrimaryButton label="Go to home" onClick={this.etGoHome} />
                    </div>
                </React.Fragment>
            )
        } else if (this.state.hasError) {
            return (
                <div className="container-fluid">
                    <ImageLoader src="https://assets.1mg.com/pwa-app/production/mweb/4.0.0/static/images/errors/500.svg" />
                    <div className="marginTop-8">
                        <h2 className={`${css.headingcolor} textCenter`}>500 Internal Server Error!</h2>
                        <p className={`${css.headingcolor} textCenter`}>
                            We are working towards creating something better. Please try again later.
                        </p>
                    </div>
                    <div className="container-fluid">
                        <PrimaryButton label="Go to home" onClick={this.etGoHome} />
                    </div>
                </div>
            )
        }

        return this.props.children
    }
}

function checkReducerAdded(state) {
    if (state) {
        return state
    } else {
        throw {
            errorCode: 424,
            message: "Reducer Errors",
        }
    }
}
export { ErrorBoundary, checkReducerAdded }
